import styled from "styled-components";
import { Scrollbar } from "@ann/web-components";
import { Modal } from "@ann/web-components";

const SPACING_6X = "8px";

export const StyledModal = styled(Modal).attrs({
  className: "conversation-history-modal",
})`
  backdrop-filter: none !important;
  background-color: transparent !important;

  & > div {
    border-radius: 16px !important;
    border: 0.5ps solid ${(props) => props.theme.colors?.silverGrayTwo};
  }

`;

export const ModalBodyInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING_6X};
  width: 100%;
  height: 100%;
  min-height: 0;
`;

export const SearchRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing?.sm ?? "8px"};
  width: 100%;
  padding: ${(props) => props.theme.spacing?.xs ?? "4px"} 0;
`;

export const SearchInputWrap = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;

  & > div > div > div {
    border: 0.5px solid #5C5C5C;
    border-radius: 8px;

  }
`;

/* Mismo estilo que New chat del Sidebar (NewChatContainer): div, no button */
export const NewChatRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  padding: 8px;
  width: 100%;
  cursor: pointer;
  border-radius: 8px;

  &:hover {
    background-color: ${(props) => props.theme.colors.ghostWhite};
  }
`;

/* Contenedor flex con gap 8px entre secciones (Today, Last 7 days) */
export const ListScroll = styled(Scrollbar).attrs({
  display: "flex",
})`
  flex: 1;
  min-height: 0;
  flex-direction: column;
  gap: 8px;
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing?.xs ?? "4px"};
`;

/* Typography Body/Regular/Small color body */
export const SectionTitle = styled.span`
  font-size: ${(props) => props.theme.fontSize?.sm ?? "12px"};
  font-weight: 400;
  color: ${(props) => props.theme.colors?.body ?? props.theme.colors?.darkGray ?? "#6B7280"};
`;

/* Contenedor por ítem: padding 2x top/bottom, 4x left/right; gap 16px; height Hug 40px; background white */
export const ConversationItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  width: 100%;
  min-height: 40px;
  padding: ${(props) => props.theme.spacing?.sm ?? "8px"} ${(props) => props.theme.spacing?.lg ?? "16px"};
  background-color: ${(props) => props.theme.colors?.white ?? "#FFFFFF"};
  cursor: pointer;
  border-radius: 6px;
  transition: background-color 0.15s ease;
  box-sizing: border-box;

  &:hover {
    background-color: ${(props) => props.theme.colors?.ghostWhite ?? "rgba(0,0,0,0.04)"};
  }
`;

export const ConversationItemIcon = styled.span`
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.colors?.body ?? "#374151"};
`;

export const ConversationItemLabel = styled.span`
  flex: 1;
  min-width: 0;
  font-size: 14px;
  color: ${(props) => props.theme.colors?.neutralBlack ?? "#1a1a1a"};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ClearSearchButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${(props) => props.theme.colors?.darkGray ?? "#6B7280"};
  border-radius: 4px;
  padding: 12px;

  &:hover {
    background: ${(props) => props.theme.colors?.ghostWhite ?? "rgba(0,0,0,0.06)"};
    color: ${(props) => props.theme.colors?.neutralBlack ?? "#1a1a1a"};
  }
`;
